import type { ComponentProps } from "react"

export default function PropertyApartmentBlock(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M26.6667 2.66675H5.33333C4.97971 2.66675 4.64057 2.80722 4.39052 3.05727C4.14048 3.30732 4 3.64646 4 4.00008V28.0001C4 28.3537 4.14048 28.6928 4.39052 28.9429C4.64057 29.1929 4.97971 29.3334 5.33333 29.3334H12V25.3334C12 24.2725 12.4214 23.2551 13.1716 22.505C13.9217 21.7548 14.9391 21.3334 16 21.3334C17.0609 21.3334 18.0783 21.7548 18.8284 22.505C19.5786 23.2551 20 24.2725 20 25.3334V29.3334H26.6667C27.0203 29.3334 27.3594 29.1929 27.6095 28.9429C27.8595 28.6928 28 28.3537 28 28.0001V4.00008C28 3.64646 27.8595 3.30732 27.6095 3.05727C27.3594 2.80722 27.0203 2.66675 26.6667 2.66675ZM14.6667 18.6667H9.33333V14.6667H14.6667V18.6667ZM14.6667 10.6667H9.33333V6.66675H14.6667V10.6667ZM22.6667 18.6667H17.3333V14.6667H22.6667V18.6667ZM22.6667 10.6667H17.3333V6.66675H22.6667V10.6667Z"
        fill={fill}
      />
    </svg>
  )
}
